import { useCallback, useRef, useState } from 'react';

import { useOutsideClick } from '@app/hooks';

export const useEmojiPicker = () => {
  const pickerRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);
  const [isEmojiOpen, setIsEmojiOpen] = useState(false);

  const toggleEmojiPicker = useCallback(() => {
    setIsEmojiOpen((prev) => !prev);
  }, []);

  const closeEmojiPicker = useCallback((event: MouseEvent) => {
    if (buttonRef.current && buttonRef.current.contains(event.target as Node)) {
      return;
    }
    setIsEmojiOpen(false);
  }, []);

  useOutsideClick(pickerRef, closeEmojiPicker);

  return {
    isEmojiOpen,
    pickerRef,
    buttonRef,
    toggleEmojiPicker,
  };
};
